var map = {
	"./5Paisa.png": 3134,
	"./AU Small finance.png": 2311,
	"./AU SwipeUp.png": 4885,
	"./Angel.png": 7773,
	"./Axis CC.png": 8940,
	"./Axis Securities.png": 1681,
	"./Axis.png": 742,
	"./Bajaj EMI Card.png": 1936,
	"./Bajaj Securities.png": 1677,
	"./Bank Of Baroda.png": 847,
	"./CASHe.png": 7560,
	"./Citi.jpg": 7849,
	"./Edelweiss.png": 1719,
	"./Equitas.png": 9623,
	"./Espresso.png": 8807,
	"./Fibe.png": 9246,
	"./Freecharge.png": 9995,
	"./FundsIndia.png": 6482,
	"./Geojit.png": 3340,
	"./Giottus.png": 6903,
	"./Groww.png": 3397,
	"./HDFC SKY.png": 4255,
	"./HDFC Securities.png": 3059,
	"./HDFC.png": 8066,
	"./ICICI Direct.png": 1768,
	"./ICICI.png": 1732,
	"./IDFC.png": 8084,
	"./India Infoline.png": 9139,
	"./IndusInd.png": 1205,
	"./Jupiter.png": 6076,
	"./Kotak 811.png": 4882,
	"./Kotak Cherry.png": 2370,
	"./Kotak.png": 312,
	"./KreditBee.png": 4007,
	"./Navi.png": 728,
	"./Niyox.png": 2621,
	"./Paytm.png": 1225,
	"./SBI Securities.png": 743,
	"./Samco.png": 50,
	"./Sas Online.png": 8840,
	"./Simpl.png": 9072,
	"./Simply save.png": 3040,
	"./Standard Chartered.png": 3880,
	"./Tide.png": 7989,
	"./Upstox.png": 1224,
	"./Yes Bank.png": 6539,
	"./Yes Securities.png": 4763,
	"./copy.png": 9634,
	"./exclamation_red.png": 3238,
	"./fi.png": 5240,
	"./iMobile.png": 8704,
	"./mStock.png": 8059
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4480;